<template>
  <div class="c-preview" v-if="value">
    <div class="ivu-modal-mask"></div>
    <div class="ivu-modal-wrap vertical-center-modal">
      <div class="m-close" @click="$emit('input', false)">
        <Icon type="ios-close" size="68" color="#efefef" />
      </div>
      <div class="m-wrap">
        <div class="m-tools">
          <u-tool v-model="current" :data="data"></u-tool>
        </div>
        <div class="m-iphone">
          <!-- iphoneX -->
          <IPhone :title="title" :theme="theme" :src="src" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IPhone from './iphone'
import uTool from './utools'
export default {
  name: 'preView',
  components: { IPhone, uTool },
  props: {
    value: {
      type: Boolean
    },
    src: {
      type: String
    },
    current: {
      type: Number
    },
    title: {
      type: String
    }
  },
  computed: {
    theme() {
      let name = ''
      const index = this.data.findIndex((ret) => ret.id === this.current)
      if (index > -1) name = this.data[index].name
      return name
    }
  },
  data() {
    return {
      data: []
    }
  },
  created() {
    this.data = [
      {
        id: 1,
        name: 'iphoneX'
      },
      {
        id: 2,
        name: 'iphone8'
      }
    ]
  }
}
</script>
<style lang="scss" scoped>
.c-preview {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(55, 55, 55, 0.6);

  .m-close {
    position: absolute;
    right: 10px;
    top: 10px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.6);
      cursor: pointer;
    }
  }

  .m-wrap {
    width: 100%;
    height: 100%;
    display: flex;

    .m-tools {
      width: 200px;
      flex: 0 0 200px;
    }

    .m-iphone {
      flex: 1 1 auto;
    }
  }
}
</style>
